import script from "./Survey.vue?vue&type=script&lang=ts&setup=true"
export * from "./Survey.vue?vue&type=script&lang=ts&setup=true"

import "./Survey.vue?vue&type=style&index=0&id=69a63328&lang=scss"

const __exports__ = script;

export default __exports__